import { clampTo, extractImageFrames } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const lumaConfigs: Record<string, WavespeedModelConfig> = {
    'luma/ray-3.2': {
        // https://wavespeed.ai/zh-CN/models/luma/ray-3.2/text-to-video
        // https://wavespeed.ai/zh-CN/models/luma/ray-3.2/image-to-video
        apiPath: (params) => {
            const frameMode = params.modelUi?.frameMode;
            if (frameMode === 'first') {
                return '/luma/ray-3.2/image-to-video';
            } else {
                return '/luma/ray-3.2/text-to-video';
            }
        },
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, quality, modelUi } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    prompt: prompt,
                    size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                    duration: `${clampTo(duration || 5, [5, 10] as const, 5)}s`,
                    resolution: clampTo(quality || '540p', ['540p', '720p', '1080p'] as const, '540p'),
                    // 首帧 URL
                    image: firstImage,
                };
            }
            // 文生视频模式
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                duration: `${clampTo(duration || 5, [5, 10] as const, 5)}s`,
                resolution: clampTo(quality || '540p', ['540p', '720p', '1080p'] as const, '540p'),
                // system
                reference: undefined,
            };
        },
    },
    'luma/ray-3.2/video-edit': {
        // https://wavespeed.ai/zh-CN/models/luma/ray-3.2/video-edit
        apiPath: '/luma/ray-3.2/video-edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, videoUri, duration, quality } = params;
            return {
                prompt: prompt,
                resolution: clampTo(quality || '540p', ['540p', '720p', '1080p'] as const, '540p'),
                duration: `${clampTo(duration || 5, [5, 10] as const, 5)}s`,
                // 视频 URL
                video: videoUri,
            };
        },
    },
    'luma/ray-3.2/video-reframing': {
        // https://wavespeed.ai/zh-CN/models/luma/ray-3.2/video-reframing
        apiPath: '/luma/ray-3.2/video-reframing',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, videoUri, aspectRatio, quality } = params;
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '1:1', '4:3', '3:4', '21:9'] as const, '16:9'),
                resolution: clampTo(quality || '540p', ['540p', '720p', '1080p'] as const, '540p'),
                // 视频 URL
                video: videoUri,
            };
        },
    },
};